import React from 'react';
import styles from 'Custom/InsertionTiming/index.module.scss';
import Container from 'Nori/Container';
import RichText from 'Custom/RichText';
import Image from 'Nori/Image';
import MAP_CONNECTOR_IMAGE from 'Images/misc/map-connector.webp';
import Button from 'Nori/Button';

const InsertionTiming = ({ className = '', children, id = '', ...props }) => {
  return (
    <section
      className={styles.sectionTiming}
      data-qa-tag="section timing insertion"
      id={id}
    >
      <div className={`${styles.wrapper} ${className}`} {...props}>
        <Container size="md">
          <RichText
            className={styles.mainContainer}
            data-qa-tag="richtext Insertion Timing"
          >
            <h2 data-qa-tag="title Insertion Timing">
              The timing of your insertion
            </h2>
            <div>
              <Image
                className={styles.mapConnector}
                src={MAP_CONNECTOR_IMAGE}
                alt=""
              />
              <div className={styles.split}>
                <div
                  className={styles.blueBlock}
                  data-qa-tag="insertion blueblock"
                >
                  <h3>
                    If inserted within the first 5 days of your normal menstrual
                    cycle
                  </h3>
                  <p className="intro">
                    No other birth control methods need to be used.
                  </p>
                </div>
                <p className={`${styles.mobileConnector} h2`}>or</p>
                <div
                  className={styles.pinkBlock}
                  data-qa-tag="insertion pinkblock"
                >
                  <h3>
                    If inserted after the 5th day of your normal menstrual cycle
                  </h3>
                  <p className="intro">
                    Then you should use an additional contraceptive method (such
                    as a condom) for the first 7 days after insertion.
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.copyBlock}>
              <h2 data-qa-tag="insertion copyblock">
                Be sure to check immediately after insertion for your NEXPLANON
                implant
              </h2>
              <p className="intro" data-qa-tag="insertion intro">
                If at any time you cannot feel the NEXPLANON implant, contact
                your doctor immediately and use a non-hormonal birth control
                method (such as condoms) until your doctor confirms that the
                implant is in place.
              </p>
              <Button
                type="primary"
                href="/what-to-expect/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Link"
                data-design-label="Learn More About Insertion Aftercare"
                data-design-nori_id="Inline Content"
                data-design-module_name="insertion aftercare"
                data-design-module_no="06"
                className={styles.cta}
                data-qa-tag="button Learn More About Insertion Aftercare"
              >
                Learn More About Insertion Aftercare
              </Button>
            </div>
          </RichText>
        </Container>
      </div>
    </section>
  );
};

export default InsertionTiming;
